import React from 'react'

const TableHeader = ({ title, className = "" }) => (
    <p className={`text-sm font-bold text-gray-600 dark:text-white ${className}`}>{title}</p>
);

export default TableHeader